export default {
  text: 'string',
  select: 'select',
  address: 'address',
  date: 'datepicker',
  email: 'email',
  textarea: 'text',
  editor: 'text',
  multiselect: 'select'
}